/**
 * Boards of area (a) — creation. OWNED BY area (a) — creation (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const creationBoards: BoardDef[] = [
  {
    id: "BO-Creation-Nouvelles",
    ref: "104",
    title: "Cabinet création — Nouvelles demandes",
    area: "creation",
    path: "/creation/nouvelles",
    href: "/creation/nouvelles",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    note: "Dossiers payés non attribués (Atelier Nord, SA Conseil…) · « Prendre en charge » attribue puis ouvre la fiche.",
    component: lazy(() => import("./boards/BO-Creation-Nouvelles")),
  },
  {
    id: "BO-Creation-Attente",
    ref: "105",
    title: "Cabinet création — Demandes en attente",
    area: "creation",
    path: "/creation/en-attente",
    href: "/creation/en-attente",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    component: lazy(() => import("./boards/BO-Creation-Attente")),
  },
  {
    id: "BO-Creation-Attente-AE",
    ref: "107",
    title: "Cabinet création — Demandes en attente · auto-entrepreneurs",
    area: "creation",
    path: "/creation/en-attente",
    href: "/creation/en-attente?type=auto-entrepreneur",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    note: "Même liste, filtre « Auto-entrepreneur » (4 cartes de pipeline).",
    component: lazy(() => import("./boards/BO-Creation-Attente-AE")),
  },
  {
    id: "BO-Creation-AttenteClient",
    ref: "106",
    title: "Cabinet création — En attente du client",
    area: "creation",
    path: "/creation/attente-client",
    href: "/creation/attente-client",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    note: "Dossiers où le client a la main (corrections, capital, paiements…).",
    component: lazy(() => import("./boards/BO-Creation-AttenteClient")),
  },
  {
    id: "BO-Creation-Terminees",
    ref: "108",
    title: "Cabinet création — Demandes terminées",
    area: "creation",
    path: "/creation/terminees",
    href: "/creation/terminees",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    note: "Créés, annulés, refusés, inactifs · lien « Compte · n services » vers BO-Mix-Client.",
    component: lazy(() => import("./boards/BO-Creation-Terminees")),
  },
  {
    id: "BO-Tiroir-Nouvelle",
    ref: "109",
    title: "Cabinet création — Nouvelle demande prise en charge",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_nouvelle",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "SA Conseil, non attribué : fiche en lecture seule + « Prendre en charge ».",
    component: lazy(() => import("./boards/BO-Tiroir-Nouvelle")),
  },
  {
    id: "BO-Tiroir-Prevalidation",
    ref: "110",
    title: "Cabinet création — Prévalidation",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_prevalidation",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "GFA Conseil (Élise Desgranges), À prévalider, attribué à Elie.",
    component: lazy(() => import("./boards/BO-Tiroir-Prevalidation")),
  },
  {
    id: "BO-Tiroir-Invalidation-Saisie",
    ref: "111",
    title: "Cabinet création — Invalidation en cours de saisie",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_prevalidation?fenetre=invalider",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Fenêtre « Invalider une réponse » (?fenetre=invalider&champ=…).",
    component: lazy(() => import("./boards/BO-Tiroir-Invalidation-Saisie")),
  },
  {
    id: "BO-Tiroir-Invalidation-Envoyee",
    ref: "112",
    title: "Cabinet création — Corrections envoyées au client",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_corrections_envoyees",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "EL Consult : 2 corrections envoyées, en attente du client.",
    component: lazy(() => import("./boards/BO-Tiroir-Invalidation-Envoyee")),
  },
  {
    id: "BO-Revue-Corrections",
    ref: "113",
    title: "Cabinet création — Revue des corrections",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_corrections_recues?fenetre=revue",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Brio Conseil : le client a répondu, revue point par point.",
    component: lazy(() => import("./boards/BO-Revue-Corrections")),
  },
  {
    id: "BO-Revue-Reinvalider",
    ref: "114",
    title: "Cabinet création — Réinvalider une réponse",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_corrections_recues?fenetre=reinvalider",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Même revue, formulaire « Réinvalider » ouvert sur le point courant.",
    component: lazy(() => import("./boards/BO-Revue-Reinvalider")),
  },
  {
    id: "BO-Tiroir-Capital",
    ref: "115",
    title: "Cabinet création — Dépôt du capital",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_capital",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Atelier Sève : en attente du dépôt du capital.",
    component: lazy(() => import("./boards/BO-Tiroir-Capital")),
  },
  {
    id: "BO-Capital-Revue",
    ref: "116",
    title: "Cabinet création — Revue de l'attestation de dépôt",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_capital_revue",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Lumen Studio (EURL 20 %) : attestation à vérifier · « Contrôler l'attestation » ouvre la revue.",
    component: lazy(() => import("./boards/BO-Capital-Revue")),
  },
  {
    id: "BO-Tiroir-Finalisation",
    ref: "117",
    title: "Cabinet création — Finalisation des documents",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_finalisation",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "HM Bât : 1 pièce à contrôler.",
    component: lazy(() => import("./boards/BO-Tiroir-Finalisation")),
  },
  {
    id: "BO-Tiroir-Pieces-Invalidation",
    ref: "118",
    title: "Cabinet création — Invalidation d'une pièce",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_finalisation?fenetre=invalider-piece",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Fenêtre « Invalider une pièce » (?fenetre=invalider-piece&piece=…).",
    component: lazy(() => import("./boards/BO-Tiroir-Pieces-Invalidation")),
  },
  {
    id: "BO-Apercu-Piece",
    ref: "119",
    title: "Cabinet création — Aperçu d'une pièce",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_finalisation?fenetre=apercu-piece",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Aperçu intégré d'une pièce (?fenetre=apercu-piece&piece=…).",
    component: lazy(() => import("./boards/BO-Apercu-Piece")),
  },
  {
    id: "BO-Apercu-Statuts",
    ref: "120",
    title: "Cabinet création — Aperçu d'un document généré",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_finalisation?fenetre=apercu-document",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Aperçu d'un document généré (?fenetre=apercu-document&doc=…).",
    component: lazy(() => import("./boards/BO-Apercu-Statuts")),
  },
  {
    id: "BO-Tiroir-Annonce-Lien",
    ref: "121",
    title: "Cabinet création — Annonce légale · lien de paiement",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_annonce_lien",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "NK Digital : annonce à préparer · « Envoyer le lien » ouvre le lien JAL.",
    component: lazy(() => import("./boards/BO-Tiroir-Annonce-Lien")),
  },
  {
    id: "BO-Tiroir-Annonce-Attente",
    ref: "122",
    title: "Cabinet création — Annonce légale · en attente du paiement",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_annonce_attente",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Orbe Conseil : lien JAL envoyé, paiement en attente.",
    component: lazy(() => import("./boards/BO-Tiroir-Annonce-Attente")),
  },
  {
    id: "BO-Tiroir-Annonce-Paye",
    ref: "123",
    title: "Cabinet création — Annonce légale · paiement reçu",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_annonce_payee",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Volta Bâtiment : annonce payée, attestation à valider.",
    component: lazy(() => import("./boards/BO-Tiroir-Annonce-Paye")),
  },
  {
    id: "BO-Tiroir-Greffe-Montant",
    ref: "123b",
    title: "Cabinet création — Frais de greffe · montant et lien de paiement",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_greffe_montant",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Atelier Mira : frais de greffe à demander.",
    component: lazy(() => import("./boards/BO-Tiroir-Greffe-Montant")),
  },
  {
    id: "BO-Tiroir-Greffe-Attente",
    ref: "123c",
    title: "Cabinet création — Frais de greffe · en attente du paiement",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_greffe_attente",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Cobalt Studio : lien des frais de greffe envoyé.",
    component: lazy(() => import("./boards/BO-Tiroir-Greffe-Attente")),
  },
  {
    id: "BO-Tiroir-Greffe-Paye",
    ref: "123d",
    title: "Cabinet création — Frais de greffe · paiement reçu",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_greffe_paye",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Sillage Conseil : frais de greffe payés · « Déposer à l'INPI ».",
    component: lazy(() => import("./boards/BO-Tiroir-Greffe-Paye")),
  },
  {
    id: "BO-Tiroir-DepotINPI",
    ref: "124",
    title: "Cabinet création — Dépôt INPI",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_depot_inpi",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "LF Studio : checklist 7/9 avant « Marquer déposé ».",
    component: lazy(() => import("./boards/BO-Tiroir-DepotINPI")),
  },
  {
    id: "BO-DepotINPI-Liasse",
    ref: "125",
    title: "Cabinet création — Enregistrer le dépôt INPI",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_depot_inpi?fenetre=liasse",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Fenêtre « Enregistrer le dépôt INPI » (numéro de liasse).",
    component: lazy(() => import("./boards/BO-DepotINPI-Liasse")),
  },
  {
    id: "BO-Tiroir-VerifINPI",
    ref: "126",
    title: "Cabinet création — Vérification INPI",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_verif_inpi",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Nacre Design : l'INPI demande un justificatif, envoyé au client.",
    component: lazy(() => import("./boards/BO-Tiroir-VerifINPI")),
  },
  {
    id: "BO-Tiroir-VerifINPI-Reponse",
    ref: "127",
    title: "Cabinet création — Transmettre la réponse à l'INPI",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_verif_inpi_reponse",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Altis Conseil : réponse du client à transmettre à l'INPI.",
    component: lazy(() => import("./boards/BO-Tiroir-VerifINPI-Reponse")),
  },
  {
    id: "BO-Tiroir-Decision",
    ref: "128",
    title: "Cabinet création — Verdict INPI",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_decision",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Prisme Studio : INPI favorable après demande · SIREN à enregistrer.",
    component: lazy(() => import("./boards/BO-Tiroir-Decision")),
  },
  {
    id: "BO-Tiroir-Decision-Sautee",
    ref: "129",
    title: "Cabinet création — Décision (vérification INPI sautée)",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_decision_sautee",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Roche Élec : INPI favorable sans demande (Vérification INPI sautée).",
    component: lazy(() => import("./boards/BO-Tiroir-Decision-Sautee")),
  },
  {
    id: "BO-Immatriculation",
    ref: "130",
    title: "Cabinet création — Enregistrer l'immatriculation (Data&Key)",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_decision?fenetre=immatriculation",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Fenêtre « Enregistrer l'immatriculation » (Data&Key ou manuel).",
    component: lazy(() => import("./boards/BO-Immatriculation")),
  },
  {
    id: "BO-Tiroir-Termine",
    ref: "131",
    title: "Cabinet création — Dossier terminé",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_maison_sarah",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    note: "Maison Sarah : société immatriculée le 02/10/2026.",
    component: lazy(() => import("./boards/BO-Tiroir-Termine")),
  },
  {
    id: "BO-Annuler-Demande",
    ref: "132",
    title: "Cabinet création — Annuler la demande",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_prevalidation?fenetre=annuler",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Fenêtre « Annuler la demande » (grille 100 / 50 / 25 / 0 %).",
    component: lazy(() => import("./boards/BO-Annuler-Demande")),
  },
  {
    id: "BO-Vue-Client",
    ref: "133",
    title: "Cabinet création — Vue client",
    area: "creation",
    path: "/creation/dossiers/$dossierId",
    href: "/creation/dossiers/dos_bo_prevalidation?fenetre=vue-client",
    permission: ["creation", "read"],
    persona: "admin",
    kind: "window",
    nav: "creation.dossiers",
    space: "creation",
    note: "Fenêtre « Vue client » : ce que le client voit (points bloquants).",
    component: lazy(() => import("./boards/BO-Vue-Client")),
  },
  {
    id: "BO-Mix-Client",
    ref: "133b",
    title: "Compte multi-services — le mix des 3 vu du back-office",
    area: "creation",
    path: "/compta/clients/$companyId/compte",
    href: "/compta/clients/cmp_atelier_nord/compte",
    permission: ["cabinet.clients", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "Atelier Nord : Création en cours + Compta à activer (PHENIX : 3 services).",
    component: lazy(() => import("./boards/BO-Mix-Client")),
  },
  {
    id: "Flows-Etats",
    ref: "102",
    title: "Machine d'états création",
    area: "creation",
    path: "/reference/creation/etats",
    href: "/reference/creation/etats",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "reference",
    nav: "reference",
    space: null,
    component: lazy(() => import("./boards/Flows-Etats")),
  },
  {
    id: "Flows-Invalidations",
    ref: "103",
    title: "Boucles d'invalidation",
    area: "creation",
    path: "/reference/creation/invalidations",
    href: "/reference/creation/invalidations",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "reference",
    nav: "reference",
    space: null,
    component: lazy(() => import("./boards/Flows-Invalidations")),
  },
];
